<template>
<ValidationObserver ref="observer">
  <form ref="add_business_unit_form" @submit.prevent="addGatePass">

    <md-card>
      <md-card-content>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="pool" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Eshed</label>
                  <md-select v-model="gate_pass_pool_id" required>
                <md-option v-for="option in options_pool_list" :key="option.value" :value="option.id">
                  {{ option.pool_name }}
                </md-option> 
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.pko_pool"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>
        


        

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="applicant" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Applicant</label>
                  <md-input v-model="gate_pass_applicant_name" required />
                  <validation-error
                    :errors="apiValidationErrors.gate_pass_applicant_name"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <label class="md-size-15 md-form-label">Start Date</label>
              <validation-provider rules="startdate" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <md-input type="date" v-model="gate_pass_start_date" required />
                  <validation-error
                    :errors="apiValidationErrors.gate_pass_start_date"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100" >
              <validation-provider rules="purpose" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Purpose</label>
                  <md-input v-model="gate_pass_purpose" required />
                  <validation-error
                    :errors="apiValidationErrors.gate_pass_purpose"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <validation-provider rules="vehicle" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label>Vehicle</label>
                <md-input placeholder="Search by using plate no" v-model="gate_pass_vehicle_plate_no" required />
                <md-button :disabled="!gate_pass_vehicle_plate_no" class="md-icon-button md-round md-info md-dense" v-on:click="findVehiclePlatNo()"><md-icon >search</md-icon></md-button>
                <validation-error
                  :errors="apiValidationErrors.gate_pass_vehicle_plate_no"
                />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
            </validation-provider>
          </div>
          <div class="md-layout-item md-small-size-100" style="margin-top:15px;">
            <validation-provider rules="vin" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label>Vin No</label>
                <md-input  v-model="gate_pass_vehicle_chassis_no" disabled required />
                <validation-error
                  :errors="apiValidationErrors.gate_pass_vehicle_chassis_no"
                />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
            </validation-provider>
          </div>
        </div>

        
        
        
      </md-card-content>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
        <!-- <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button> -->
      </md-card-actions>
    </md-card>
  </form>
</ValidationObserver>
  
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend , validate, localize , ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Swal from 'sweetalert2';


// mengirim pesan error ketika required field tidak diisi

extend('applicant', {
  ...required,
  message: 'Applicant Field is required'
});

extend('startdate', {
  ...required,
  message: 'Start Date Field is required'
});

extend('purpose', {
  ...required,
  message: 'Purpose Field is required'
});

extend('vehicle', {
  ...required,
  message: 'Plate No Field is required'
});

extend('vin', {
  ...required,
  message: 'Vin No Field is required'
});

extend('pool', {
  ...required,
  message: 'Eshed Field is required'
});
  
  export default {
     name: "add-business-unit",

    props: {
      data: Object
    },

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

    data: () => ({
      gate_pass_applicant_name: null,
      gate_pass_start_date: null,
      gate_pass_purpose: null,
      gate_pass_vehicle_plate_no : null,
      gate_pass_vehicle_chassis_no : null,
      options_pool_list: null,
      gate_pass_pool_id: null
    }),

    // created() {
    //   this.getLastNo();
    // },

    created(){
      this.getDataPool();
    },

  
    methods: {

      async getDataPool(){
        await this.$store.dispatch("workshop_pool/list")
        this.options_pool_list = await this.$store.getters["workshop_pool/list"];
      },


      // fungsi untuk tombol direct ke list client master
      backtoList(id) {
      this.$router.replace({ name: 'List Gate Pass' })
    },

    setData(data){
      this.gate_pass_vehicle_id = data.id
      // this.checker.vehicle_plate_no = data.vehicle_plate_no
      this.gate_pass_vehicle_chassis_no = data.vehicle_engine_no
      this.dataValid = true

    },

    async findVehiclePlatNo(){
      var query = {}
      query.filter = {find_vehicle_plate_no:this.gate_pass_vehicle_plate_no}
      await this.$store.dispatch("workshop_vehicle/list", query)
       var data = await this.$store.getters["workshop_vehicle/list"];
      if(Object.keys(data).length!=0){
           this.setData(data[0])
       }
       else{
         this.swalFindError()
         this.dataValid = false
          this.gate_pass_vehicle_plate_no = null
       }
        //  this.swalFindError()
        //  this.dataValid = false
        //   this. checker.id = data.id
        //   this.checker.vehicle_plate_no = data.vehicle_plate_no
        //   this.checker.vehicle_door_no = data.vehicle_door_no
       
    },

    swalFindError(){
      this.gate_pass_vehicle_plate_no = null,
      this.gate_pass_vehicle_chassis_no = null
      Swal.fire({
          icon: 'error',
          title: 'Not Found',
          text: 'Data kendaraan tidak ditemukan',
        })
    },

    // onChangeCategory(){
    // },


     // validasi menggunakan sweetalert  sebelum menambah data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
    Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.addGatePass()
          }
        });
    },


    // fungsi add data
      async addGatePass() {
       

        const data = {
          type: "workshop_gate_passes",
          // client_no: this.client_no,
          gate_pass_applicant_name: this.gate_pass_applicant_name,
          gate_pass_start_date: this.gate_pass_start_date,
          gate_pass_purpose: this.gate_pass_purpose,
          gate_pass_vehicle_id: this.gate_pass_vehicle_id,
          gate_pass_pool_id: this.gate_pass_pool_id
        }


        try {
        await this.$store.dispatch("workshop_gate_pass/add", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        // await this.$router.replace({name: 'List Gate Pass'});
        this.$parent.$parent.modalCloseAdd();
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      }
    }
  };
</script>
